{
  "circuits": {
    "actions": {
      "actions": "Actions",
      "labels": {
        "circuit": "Circuit:",
        "circuit_name": "Circuit name:",
        "site": "Site:"
      }
    },
    "advanced-options": "Advanced options",
    "bigleaf_wireless_connect": {
      "init": {
        "info": "You’ve selected Bigleaf Wireless Connect. Choose a wireless plan and save the circuit. It will remain in “setup started” mode until Bigleaf activation.",
        "shipping_address": "Please double-check your shipping address before you save the circuit configuration, to make sure we send the hardware to the right place."
      },
      "provisioning": {
        "badge": "Setup started",
        "info": "You've opted for Bigleaf Wireless Connect service for this circuit. To change or cancel service, please contact <a>Bigleaf Support</a>."
      }
    },
    "block-circuit": {
      "confirm": {
        "button": "Block circuit",
        "cancel": "Cancel",
        "header": "Block this circuit?",
        "line_1": "This may interrupt your Bigleaf service and take your site offline, so make sure another circuit is active before continuing.",
        "line_2": "Because data metering is enabled, the circuit will be automatically unblocked on the first day of the next billing period.",
        "warning": "Blocking this circuit will take it offline immediately."
      },
      "description": "Puts this circuit offline and stops all traffic.",
      "header": "Block circuit",
      "success": "Circuit has been blocked",
      "tooltip": "To unblock this circuit, open the drop-down menu on the top-right of this card."
    },
    "delete-circuit": {
      "cancel-setup": "Cancel circuit setup",
      "header": "Delete circuit",
      "mark-for-deletion": "Mark circuit for deletion",
      "marked-for-deletion-description": "Circuit marked for deletion",
      "unmark-for-deletion": "Unmark for deletion",
      "warning": "Deleting circuit is irreversible and can dramatically affect your site's functionality. Proceed with caution. The circuit will not be deleted until you save the settings."
    },
    "disable-circuit": {
      "cancel-setup": "Cancel circuit setup",
      "header": "Request disabling circuit",
      "mark-for-deletion": "Request disabling circuit",
      "marked-for-deletion-description": "Circuit marked for disabling",
      "unmark-for-deletion": "Cancel disable request",
      "warning": "Disabling circuit is irreversible and can dramatically affect your site's functionality. Proceed with caution. The circuit will not be disabled until you save the settings."
    },
    "integrated-circuit": {
      "add-circuit": "Add cellular circuit",
      "disable-circuit": "Disable circuit",
      "enable-circuit": "Enable cellular circuit",
      "init": {
        "additional-info": "You can enable the wireless circuit yourself or ask Bigleaf to do it for you.",
        "contact-bigleaf": "Contact Bigleaf",
        "info": "This site has an integrated 5G/LTE circuit. Contact Bigleaf to get started with Bigleaf Wireless Connect."
      },
      "provisioning": {
        "badge": "Setup started"
      }
    },
    "integrated_circuit_subtitle": "You can have up to four circuits. WAN1, WAN2, WAN3 are meant for external circuits, while WAN4 is reserved exclusively for an integrated 5G/LTE circuit",
    "reset-circuit": {
      "confirm": {
        "button": "Reset the circuit",
        "cancel": "Cancel",
        "header": "Are you sure you want to reset this circuit?",
        "labels": {
          "circuit": "Circuit:",
          "circuit_name": "Circuit name:"
        },
        "line_1": "Resetting this circuit may help fix issues with your ISP connection.",
        "line_2": "This may briefly interrupt your Bigleaf service, so make sure another circuit is active before continuing."
      },
      "description": "Reset the specified circuit interface to resolve issues encountered when traversing an ISP network. This may cause temporary service  interruption.",
      "header": "Reset circuit",
      "success": "The Reset Circuit job has been submitted. <a>Click here</a> to view the results."
    },
    "subtitle-fields": {
      "name": "Name",
      "speed": "Speed",
      "type": "Type"
    },
    "title": "Circuits",
    "tunnel-protocols": "Tunnel protocols",
    "unblock-circuit": {
      "confirm": {
        "button": "Unblock circuit",
        "cancel": "Cancel",
        "header": "Unblock this circuit?",
        "line_1": "Unblocking this circuit will bring it back online immediately.",
        "line_2": "Because data metering is enabled, this override will stay in effect until the next billing period begins, when data usage resets."
      },
      "description": "Puts this circuit back online and resumes all traffic.",
      "header": "Unblock circuit",
      "success": "Circuit has been unblocked"
    },
    "unconfigured-circuit": {
      "configure": "Configure",
      "contact-bigleaf": "Contact Bigleaf",
      "enable-wireless-circuit": "Enable wireless circuit",
      "integrated-circuit": "This site features an integrated 5G circuit that supports <strong>Bigleaf Wireless Connect</strong>. For more details or to set up the service, please contact Bigleaf.",
      "unconfigured": "Unconfigured"
    },
    "wan": "WAN{{wanIndex}}"
  },
  "device_sync_indicator": {
    "error": "Device(s) are not synced with site configuration. Ensure devices are powered on and connected to the internet.",
    "in-progress": "Device(s) are currently being synced with site configuration.",
    "success": "Device(s) are synced with site configuration."
  },
  "devices": {
    "devices": {
      "add-device-drawer": {
        "add-device": "Add device",
        "assign-router": "Assign router",
        "choose-existing-device": "Choose existing device",
        "choose-role": "Choose role",
        "description": "To connect a new device, make sure to add the hardware to your <Link>Company</Link> first. Once it's added there, you can connect it here to the site.",
        "failover-router": "Secondary Router",
        "no-available-routers": "No routers available to add",
        "no-routers-found": "No routers found",
        "primary-router": "Primary Router",
        "title": "Devices"
      },
      "add-new-router-failure": "Unable to add router, please try again.",
      "add-new-router-success": "Router added",
      "assign-router": "Assign router",
      "cpe-status": {
        "out_of_date": "Out of date",
        "unknown": "Unknown",
        "up_to_date": "Up to date"
      },
      "delete": {
        "cancel-setup": "Cancel router setup",
        "label": "Remove router from the site",
        "mark-for-deletion": "Remove router",
        "marked-for-deletion-description": "Router marked for removal",
        "unmark-for-deletion": "Unmark for removal"
      },
      "device-details": "Device details",
      "failover-routers": "Secondary routers",
      "no-failover-routers": "No secondary routers configured",
      "no-primary-routers": "No primary routers configured",
      "primary-routers": "Primary routers",
      "remove-router": "Remove router",
      "remove-router-from-site": "",
      "title": "Devices",
      "warnings": {
        "cpe-service-plan": "This CPE is not recommended for the current service plan. Contact support if you have any questions.",
        "data-metering": "This router does not support Data Metering, which is currently enabled. Please upgrade the firmware to avoid potential issues."
      }
    },
    "drawer": {
      "title": "Devices Status"
    },
    "ports": {
      "auto": "Auto",
      "aux": "AUX",
      "exp1": "EXP 1",
      "exp2": "EXP 2",
      "exp3": "EXP 3",
      "exp4": "EXP 4",
      "lan": "LAN",
      "off": "Off",
      "on": "On",
      "title": "Ports",
      "wan": "WAN {{index}}"
    }
  },
  "firewall_rules": {
    "delete_dialog": {
      "api_error": "There was an error deleting firewall rule.",
      "delete_success": "Successfully deleted firewall rule.",
      "text": "Are you sure you want to delete this firewall rule?"
    },
    "drawer": {
      "form": {
        "fields": {
          "action": {
            "label": "Action",
            "options": {
              "allow": "Allow",
              "deny": "Deny",
              "drop": "Drop"
            }
          },
          "description": {
            "label": "Description",
            "placeholder": "e.g. Block guest web traffic"
          },
          "destination_network": {
            "label": "Destination network(s)",
            "message": "Select existing network(s) or enter in CIDR format",
            "placeholder": "e.g. 192.168.1.0/24"
          },
          "destination_ports": {
            "label": "Destination port(s)",
            "placeholder": "Port or port range, e.g., \"22\" or \"22-24\""
          },
          "protocol": {
            "label": "Protocol",
            "options": {
              "any": "Any",
              "icmp": "ICMP",
              "tcp": "TCP",
              "udp": "UDP"
            }
          },
          "source_network": {
            "label": "Source network(s)",
            "message": "Select existing network(s) or enter in CIDR format",
            "placeholder": "e.g. 192.168.1.0/24"
          },
          "source_ports": {
            "label": "Source port(s)",
            "placeholder": "Port or port range, e.g., \"22\" or \"22-24\""
          }
        },
        "validation": {
          "invalid_cidr": "'{{value}}' is not a valid CIDR or IP address",
          "invalid_port": "Invalid port range format",
          "max_length": "Field must be at most {{length}} characters",
          "not_allowed": "{{value}} is not allowed"
        }
      },
      "header": {
        "description": "Control traffic to/from your network. Use this rule to allow or block access to specific IPs or ports.",
        "title": {
          "add": "New firewall rule",
          "edit": "Edit firewall rule"
        }
      },
      "submit": {
        "add": "Add rule",
        "edit": "Save rule",
        "success": "Successfully saved firewall rule."
      },
      "title": "Firewall Rules"
    },
    "table": {
      "action": {
        "allow": "Allow",
        "deny": "Deny",
        "drop": "Drop"
      },
      "actions": {
        "delete": "Delete firewall rule",
        "edit": "Edit firewall rule",
        "error": {
          "fetch": "Failed to load firewall rule.",
          "priority": "Failed to update firewall rule priority.",
          "toggle_enabled": "Failed to update firewall rule enabled state.",
          "toggle_logging": "Failed to update firewall rule logging state."
        },
        "priority_down": "Decrease priority",
        "priority_up": "Increase priority",
        "toggle_enabled": "Toggle rule enabled",
        "toggle_logging": "Toggle rule logging"
      },
      "add": {
        "button": "New firewall rule"
      },
      "any": "Any",
      "column": {
        "action": "Action",
        "description": "Description",
        "destination_network": "Destination CIDR(s)",
        "destination_ports": "Destination ports",
        "enabled": "Enabled",
        "hits": "Hits",
        "hits_tooltip": "Counts each new connection attempt that matches the rule within the last 7 days.",
        "hits_tooltip_icon_label": "Hits column information",
        "logging": "Logging",
        "priority": "Rule #",
        "protocol": "Protocol",
        "source_network": "Source CIDR(s)",
        "source_ports": "Source ports"
      },
      "no_data": "No firewall rules defined",
      "port_range": "{{port_start}} - {{port_end}}",
      "subtitle": "Firewall rules determine traffic behavior. Higher rules override lower ones. Changes take effect upon saving.",
      "title": "Firewall rules",
      "total_cidrs": "CIDR(s)"
    }
  },
  "form": {
    "errors": {
      "duplicate_wan": "Duplicate WAN indexes not supported",
      "enable_dhcp": "Enabling DHCP requires at least one existing LAN network",
      "enable_firewall": "Since Wi-Fi depends on NAT Firewall, you must disable Wi-Fi before changing the LAN mode.",
      "header": "Unable to save changes due to the following errors:",
      "incompatible_cpe": "The selected router \"{{cpeSerial}}\" doesn't support High Availability configuration. Select a different router that supports High Availability, or change to a standard availability plan.",
      "invalid_ip": "Invalid IP",
      "invalid_subnet": "Invalid subnet",
      "required": "This field is required",
      "summary_header": "Please fix the following errors and then save again:",
      "summary_line": "{{field}} - {{message}}",
      "switch_ip_required": "At least one network is required to have this specified",
      "value_error": {
        "max_length": "Field must be at most {{length}} characters",
        "max_size": "Field is capped at a maximum of {{limit}}",
        "min_length": "Field must be at least {{length}} characters",
        "min_size": "Field must be a minimum of {{limit}}",
        "missing": "Field is required"
      }
    },
    "fields": {
      "address": {
        "city": {
          "label": "City"
        },
        "country": {
          "label": "Country"
        },
        "line1": {
          "label": "Address line 1",
          "placeholder": "Search address"
        },
        "line2": {
          "label": "Address line 2",
          "placeholder": "Apartment, landmark, etc."
        },
        "name": {
          "label": "Full name"
        },
        "state": {
          "label": "State"
        },
        "zip": {
          "label": "Zip code"
        }
      },
      "circuit": {
        "autoblock_on_data_limit": {
          "description": "Automatically block the circuit at the configured data threshold. Blocking may take a few minutes to activate, so conservative thresholds are recommended to avoid overages.",
          "label": "Stop all traffic if data limit is reached"
        },
        "bwc_provisioned": {
          "label": "Provisioned"
        },
        "circuit_id": {
          "label": "ID"
        },
        "data_billing_end": {
          "label": "Billing period reset date",
          "tooltip": "Choose the day of the month when the usage counter should reset (at 00:00 UTC). This date stays the same every month (e.g., always resets on the 1st or 15th)."
        },
        "data_limit": {
          "label": "Data limit",
          "tooltip": "Enter the data usage limit for the selected billing period. Alerts and circuit actions will be triggered as usage approaches or exceeds this threshold."
        },
        "data_metering_enabled": {
          "label": "Enable data metering",
          "tooltip": "Data metering lets you set a monthly data limit for each circuit. It tracks how much data the circuit uses and can automatically stop all traffic when the limit is reached. You can manually unblock the circuit at any time or adjust the limit in your settings.",
          "tooltip_disabled": "Data metering is not supported until firmware version 1.2.1. Please upgrade this device’s firmware to utilize this feature."
        },
        "download": {
          "label": "Download speed"
        },
        "iccid": {
          "label": "ICCID"
        },
        "imei": {
          "label": "IMEI"
        },
        "mtu": {
          "errors": {
            "min-max": "MTU must be between 1280 and 1500 bytes."
          },
          "info": "The MTU configuration you are about to set will not be applied to all the circuit’s tunnels.",
          "label": "MTU"
        },
        "name": {
          "label": "Name"
        },
        "primary_te_primary_cpe": {
          "label": "Primary tunnel protocol"
        },
        "qos0": {
          "label": "Other",
          "tooltip": "Anything not matched for the above"
        },
        "qos1": {
          "label": "Bulk Data",
          "tooltip": "Netflix, YouTube, Dropbox uploads, other large HTTP(s) or FTP streams"
        },
        "qos2": {
          "label": "Interactive",
          "tooltip": "FTP, VPNs, SNMP, HTTP"
        },
        "qos3": {
          "label": "Urgent",
          "tooltip": "Remote Desktop, Citrix, Interactive Applications"
        },
        "qos4": {
          "label": "Real-Time",
          "tooltip": "ICMP, DNS, SSH"
        },
        "qos5": {
          "label": "VoIP",
          "tooltip": "VoIP (signaling and media)"
        },
        "reset_dscp_mark": {
          "label": "Reset DSCP",
          "values": {
            "false": "Disabled",
            "true": "Enabled"
          }
        },
        "secondary_te_primary_cpe": {
          "label": "Secondary tunnel protocol"
        },
        "secondary_wan_address": {
          "label": "Static IP address"
        },
        "secondary_wan_gateway": {
          "label": "Gateway IP address"
        },
        "secondary_wan_protocol": {
          "label": "Secondary protocol"
        },
        "secondary_wan_subnet": {
          "label": "Subnet mask"
        },
        "type": {
          "label": "Type"
        },
        "upload": {
          "label": "Upload speed"
        },
        "usage_setting": {
          "label": "Circuit usage",
          "options": {
            "avoid": "Avoid",
            "backup": "Backup Only",
            "block": "Block",
            "custom": "Custom Settings",
            "load_balance": "Load Balance"
          },
          "tooltip": {
            "avoid": "<u>Avoid</u> adjusts the load balancing algorithm per-QoS-class to prefer Load Balance circuits unless there are circuit monitoring alerts on available Load Balance circuits.",
            "backup": "<u>Backup Only</u> will use this circuit <b>only</b> when all other circuits are down.",
            "content": "$t(form.fields.circuit.usage_setting.tooltip.load_balance)<br/>$t(form.fields.circuit.usage_setting.tooltip.avoid)<br/>$t(form.fields.circuit.usage_setting.tooltip.backup)<br/>$t(form.fields.circuit.usage_setting.tooltip.custom)",
            "custom": "<u>Custom settings</u> allow per-QoS-class selection from the above three options, as well as a 'block' mode.",
            "header": "Change the load balancing behavior of this circuit",
            "load_balance": "<u>Load balance</u> sets the circuit to default Bigleaf load balancing."
          },
          "warning": {
            "block": "Warning: If all other circuits are down, all traffic in this traffic class will be dropped.",
            "load_balance": "Warning: The recommended setting of load balance no longer applies to this traffic class."
          }
        },
        "vlan_id": {
          "label": "VLAN ID",
          "tooltip": "Assign a unique identifier to a Virtual LAN on the circuit (from 1 to 4094, or leave empty if a VLAN ID is not in use)."
        },
        "wan_address": {
          "label": "Static IP address"
        },
        "wan_gateway": {
          "label": "Gateway IP address"
        },
        "wan_index": {
          "label": "Router port",
          "options": {
            "wan1": "WAN 1",
            "wan2": "WAN 2",
            "wan3": "WAN 3",
            "wan4": "WAN 4"
          }
        },
        "wan_pppoe_pass": {
          "label": "Password"
        },
        "wan_pppoe_user": {
          "label": "Username"
        },
        "wan_protocol": {
          "label": "Protocol",
          "options": {
            "dhcp": "DHCP",
            "pppoe": "PPPoE",
            "static_ip": "Static IP"
          }
        },
        "wan_subnet": {
          "label": "Subnet mask"
        },
        "wireless_plan_id": {
          "label": "Wireless plan",
          "placeholder": "Select wireless plan"
        }
      },
      "cpe": {
        "active_state": {
          "label": "Active",
          "label_collapsed": "State",
          "values": {
            "ACTIVE": "Active",
            "STANDBY": "Inactive"
          }
        },
        "config_ip": {
          "label": "Config IP"
        },
        "cpe_id": {
          "label": "ID"
        },
        "cpe_release_version": {
          "label": "Firmware version"
        },
        "cpe_role_id": {
          "label": "Role",
          "options": {
            "primary": "Primary router",
            "primary_ha": "Primary router",
            "secondary_ha": "Secondary router"
          }
        },
        "cpe_serial": {
          "label": "Serial number"
        },
        "device_type": {
          "label": "Type"
        },
        "phloem_status": {
          "label": "Server status"
        },
        "xylem_cpe_version": {
          "label": "Site config version"
        }
      },
      "cpe_link": {
        "autonegotiation": {
          "label": "Autonegotiation"
        },
        "duplex": {
          "label": "Duplex",
          "options": {
            "FULL": "FULL",
            "HALF": "HALF"
          }
        },
        "link_speed": {
          "label": "Linkspeed"
        }
      },
      "current_service_plan": {
        "config_name": {
          "label": "Availability"
        },
        "service_id": {
          "label": "Service plan",
          "placeholder": "Select plan..."
        },
        "service_tag": {
          "label": "Service tier",
          "placeholder": "Select tier..."
        }
      },
      "exp_port": {
        "port_function": {
          "label": "Port function"
        }
      },
      "lan_mode": {
        "dhcp_network_id": {
          "label": "LAN network"
        },
        "firewall_gateway": {
          "label": "Default gateway"
        },
        "firewall_subnet_mask": {
          "label": "Subnet mask"
        },
        "mode": {
          "label": "Mode",
          "options": {
            "dhcp": "DHCP",
            "firewall": "NAT firewall",
            "firewall_vlans": "NAT firewall + VLANs",
            "static": "Static"
          }
        }
      },
      "lan_network": {
        "enabled": {
          "label": "Enable for use",
          "values": {
            "false": "Disabled",
            "true": "Enabled"
          }
        },
        "ha_switch": {
          "label": "Switch"
        },
        "ha_vip": {
          "label": "Default gateway"
        },
        "pop_id": {
          "label": "PoP"
        },
        "prefix": {
          "label": "Block size"
        },
        "primary_cpe": {
          "label": "Default gateway"
        },
        "primary_ip": {
          "label": "Primary router"
        },
        "primary_netmask": {
          "label": "Subnet mask"
        },
        "secondary_cpe": {
          "label": "Secondary router"
        },
        "unused_ips": {
          "label": "Usable IPs"
        }
      },
      "lan_route": {
        "enabled": {
          "label": "Enable for use",
          "values": {
            "false": "Disabled",
            "true": "Enabled"
          }
        },
        "gateway": {
          "label": "Routed via"
        },
        "netmask": {
          "label": "Subnet mask"
        },
        "network_address": {
          "label": "Address block"
        },
        "pop_id": {
          "label": "PoP"
        },
        "prefix": {
          "label": "Block size"
        }
      },
      "rule": {
        "description": {
          "label": "Optional notes"
        },
        "qos_class": {
          "label": "Traffic type"
        },
        "rule_data": {
          "label": "Rule"
        }
      },
      "site": {
        "alert_email": {
          "label": "Email site alerts",
          "values": {
            "false": "Not enabled",
            "true": "Enabled"
          }
        },
        "aux_port_enable_lan": {
          "label": "Enable as 2nd LAN port"
        },
        "billing_type_id": {
          "label": "Billing type"
        },
        "company_id": {
          "label": "Company"
        },
        "config_version": {
          "label": "Site config version"
        },
        "cpe_local_cli_enabled": {
          "label": "Enable local CLI",
          "values": {
            "false": "Not enabled",
            "true": "Enabled"
          }
        },
        "cpe_local_ui_enabled": {
          "label": "Enable local UI",
          "values": {
            "false": "Not enabled",
            "true": "Enabled"
          }
        },
        "drain_tunnel": {
          "label": "Drain tunnel traffic",
          "values": {
            "false": "Not supported",
            "true": "Supported"
          }
        },
        "email_subject_prefix": {
          "label": "Email subject prefix"
        },
        "firewall_network": {
          "label": "Public network"
        },
        "firewall_private_network": {
          "label": "Private network"
        },
        "global_device_policy": {
          "confirmation": {
            "allow": "Any non-guest LAN clients using the default policy will be able to join the network. To avoid this, first set the device access policy for any LAN clients you do not want to join the network to “Block”. <br/><b>Are you sure you want to make this default policy change?</b>",
            "block": "Any non-guest LAN clients using the default policy will become disconnected from the network. To avoid this, first set any important LAN clients to “Allow” before making this change to the device default access policy. <br/><b>Are you sure you want to make this default policy change?</b>"
          },
          "label": "Device default access policy",
          "options": {
            "Allow": "Allow",
            "Block": "Block"
          },
          "tooltip": "Device access policy applies to all clients except those on the guest Wi-Fi network."
        },
        "name": {
          "label": "Site name"
        },
        "netsuite_id": {
          "label": "NetSuite ID"
        },
        "primary_pop_id": {
          "label": "Primary PoP (Point of Presence)"
        },
        "primary_te_id": {
          "label": "Primary TE"
        },
        "secondary_pop_id": {
          "label": "Secondary PoP (Point of Presence)"
        },
        "secondary_te_id": {
          "label": "Secondary TE"
        },
        "security_suite": {
          "label": "Edge Firewall"
        },
        "site_id": {
          "label": "Site id"
        },
        "wifi": {
          "label": "Wi-Fi service"
        }
      },
      "wifi": {
        "active": {
          "label": "Wi-Fi service"
        },
        "broadcast_ssid": {
          "label": "Enable broadcast SSID"
        },
        "channel": {
          "label": "Channel"
        },
        "guest_lan": {
          "gateway": {
            "label": "Default gateway"
          },
          "subnet": {
            "label": "Subnet mask"
          }
        },
        "ssid": {
          "label": "Wi-Fi network name (SSID)"
        },
        "vlan_network_id": {
          "label": "VLAN ID",
          "placeholder": "Select VLAN ID"
        },
        "wpa_passphrase": {
          "label": "Password",
          "requirements_message": "Password must be at least 8 characters and at most 63 characters"
        }
      }
    },
    "success": "Changes saved successfully.",
    "warnings": {
      "bwc-circuit": "Circuits of type 'Bigleaf Wireless Connect' with a plan size of 20GB generally should have the 'Backup Only' load balancing setting",
      "cellular-circuit": "Circuits of type 'Cellular' generally should have the 'Backup Only' load balancing setting",
      "cpes-service-plan": "The service plan {{servicePlan}} is not recommended for the active CPEs: {{cpeNames}}.",
      "firewall-mode": "Switching away from NAT firewall mode will remove all port forwarding rules, revert any static IP assignments, revert any MAC filtering settings, and prevent you from managing LAN clients. Are you sure you want to do this?",
      "header": "Please review the following warnings before continuing:",
      "wifi-active": "You have at least one Wi-Fi SSID active. Disabling the Wi-Fi service will turn off all SSIDs and all of your Wi-Fi clients will be disconnected. Are you sure you want to do this"
    }
  },
  "general": {
    "copy_all": "Copy all",
    "delete-site": {
      "confirm-header": "Are you sure you want to delete this site?",
      "confirm-message": "<p>You are about to delete the site:</p><Site>{{siteName}}<DoubleBadge>{{siteId}}</DoubleBadge></Site><p><b>Deleting your site is permanent</b>. Once you delete this site, all content, settings, and associated data and configuration will be <b>permanently erased</b>.</p><p><b>This action cannot be undone, and no recovery will be possible.</b></p>",
      "delete-message": "<b>Deleting your site is permanent.</b> Once you delete this site, all content, settings, and associated data and configuration will be permanently erased. This action cannot be undone, and no recovery will be possible.",
      "delete-site": "Delete site",
      "error": "Unable to delete site. Please try again.",
      "keep-site": "Keep the site",
      "title": "Delete site"
    },
    "service-options": {
      "alerts": {
        "disabled-by-cpe": "This service plan is not recommended for CPE selected. Contact support if you have any questions.",
        "firewall-lan-mode": "Firewall LAN Network Mode will be selected automatically",
        "inactive-plan": "This legacy service plan remains usable for configured sites, but upgrading to our new service plans is recommended.",
        "te-not-supported": "Your current Bigleaf Tunnel Endpoint does not fully support your current Service Plan. Please contact Bigleaf Support for further details"
      },
      "billing_warning": "Service options may impact your subscription billing.",
      "edge-firewall-disabled": "Your CPE firmware must be 1.4.0 or newer to support Edge Firewall. Please contact Bigleaf Support to upgrade your firmware",
      "reload_plans_button": "Reload plans",
      "security_suite_disable_confirmation": "All Edge Firewall features will be disabled. Existing configuration will be preserved and can be re-enabled later.",
      "security_suite_enable_confirmation": "Your site will be automatically reconfigured to NAT Firewall mode to enable Edge Firewall features. This will modify your current LAN settings.",
      "security_suite_ha": "Only available with Standard or Warm Spare Availability service",
      "service_plans_load": "Unable to load service plans due to a network or server error.",
      "title": "Service options",
      "wifi-disabled": "Your CPE firmware is too old to support Wi-Fi. Reach out to support to upgrade your firmware"
    },
    "site-address": {
      "ship-to-custom-address": "Ship to custom address",
      "ship-to-site-address": "Ship to site address",
      "shipping-information": "Shipping information",
      "title": "Site address"
    },
    "site-settings": {
      "title": "Site settings"
    },
    "tunnel-endpoints": {
      "auto-select": "Auto-select",
      "changing": "Changing...",
      "configure_with_pops": "Configure with PoPs",
      "configure_with_tes": "Configure with TEs",
      "no_pop": "No POP Selected",
      "no_te": "No TE Selected",
      "select_pop": "Select a PoP...",
      "title": "Points of Presence (PoP)",
      "unknown": "Unknown"
    }
  },
  "heading": {
    "circuits": "Site Circuit Configuration",
    "configuration_sections": "Configuration sections:",
    "custom_qos": "Custom QoS Rules",
    "devices": "Devices and Ports",
    "general": "Site General Settings",
    "go_to_overview": "Go to site overview",
    "lan_settings": "LAN Settings",
    "site_configuration": "Site Configuration",
    "staging": {
      "close": "Close",
      "review-and-apply": "Review & Apply Changes",
      "staged-config": "You are in staged configuration mode. Changes won't go live until you apply changes."
    }
  },
  "lan_clients": {
    "table": {
      "add": {
        "button": "Add LAN client",
        "error": "Unable to add LAN Client. Please try again.",
        "fields": {
          "device_policy": {
            "label": "Policy",
            "options": {
              "Allow": "Allow",
              "Block": "Block"
            },
            "placeholder": "Default policy",
            "tooltip": "Device access policy applies to all clients except those on the guest Wi-Fi network."
          },
          "mac": {
            "invalid": "Invalid MAC address",
            "label": "MAC address"
          },
          "name": {
            "label": "Client name",
            "tooltip": "If omitted, the DHCP server will determine the client’s name."
          },
          "static_ip": {
            "in_use": "This IP address is already assigned. Choose another IP address.",
            "invalid": "Invalid IP",
            "label": "Static IP",
            "tooltip": "If omitted, the DHCP server will assign a dynamic IP address to this client."
          }
        },
        "sub_header": "New LAN Client",
        "submit": "Add LAN client",
        "success": "You've successfully added a new LAN Client.",
        "title": "LAN Clients"
      },
      "blocked_devices": {
        "label": "{{count}} devices blocked",
        "tooltip": "Click to view blocked devices"
      },
      "columns": {
        "actions": "Actions",
        "connection_type": "Connection type",
        "device_policy": "Policy",
        "ip": "IP Address",
        "last_connected": "Last connected",
        "mac": "MAC Address",
        "name": "Client name",
        "ssid": "SSID",
        "status": "Connection Status"
      },
      "connection_type": {
        "ethernet": "Ethernet",
        "wi_fi": "Wi-Fi"
      },
      "default_policy_warning": {
        "description": "New and unrecognized devices on this network will be blocked automatically.",
        "title": "Device default access policy is set to Block."
      },
      "delete": {
        "confirm_text": "Are you sure you want to delete this LAN Client?",
        "error_status": "You can only delete an offline client",
        "success": "LAN Client has been successfully deleted."
      },
      "download_button": "Export as CSV",
      "edit": {
        "fields": {
          "connection_type": {
            "label": "Connection type"
          },
          "device_policy": {
            "label": "Policy",
            "options": {
              "Allow": "Allow",
              "Block": "Block"
            },
            "placeholder": "Default policy",
            "tooltip": "Device access policy applies to all clients except those on the guest Wi-Fi network."
          },
          "ip": {
            "address": {
              "in_use": "This IP address is already assigned. Choose another IP address.",
              "invalid": "Invalid IP",
              "label": "IP Address"
            },
            "static": {
              "label": "Static"
            }
          },
          "last_connected": {
            "label": "Last connected"
          },
          "mac": {
            "label": "MAC address"
          },
          "name": {
            "label": "Client name"
          },
          "ssid": {
            "label": "SSID"
          },
          "status": {
            "label": "Connection status"
          }
        },
        "sub_header": "LAN Client",
        "submit": "Save LAN client",
        "success": "You've successfully updated the LAN Client.",
        "title": "Edit LAN Clients"
      },
      "filters": {
        "connection_type": {
          "label": "Connection type",
          "options": {
            "2.4Ghs": "Wi-Fi 2.4GHz",
            "5Ghs": "Wi-Fi 5GHz",
            "ethernet": "Ethernet"
          }
        },
        "device_policy": {
          "label": "Policy",
          "options": {
            "Allow": "Allow",
            "Block": "Block"
          }
        },
        "ip": {
          "dynamic": "Dynamic",
          "label": "IPs",
          "static": "Static"
        },
        "path": "Sites > Site Configuration > LAN Clients > LAN Clients table",
        "ssid": {
          "label": "SSID"
        },
        "vlan": {
          "label": "VLAN"
        }
      },
      "ip": {
        "static": "Static"
      },
      "no_data": "No LAN Clients available",
      "title": "LAN Clients",
      "toggle_clients_online": "Show only clients online"
    }
  },
  "lan_settings": {
    "lan_routes_table": {
      "actions": {
        "delete": "Delete",
        "edit": "Edit",
        "new": "New LAN route"
      },
      "columns": {
        "enabled": "Enabled",
        "gateway": "Routed Via",
        "netmask": "Subnet Mask",
        "network": "LAN Route",
        "network_address": "Address Block",
        "pop_id": "POP"
      },
      "delete": {
        "confirm": "Are you sure you want to delete this LAN route?",
        "success": "LAN route has been successfully deleted."
      },
      "drawer": {
        "configure-manually": "Configure manually",
        "configure-with-allocation": "Configure with allocation",
        "new": "New LAN Route",
        "submit": {
          "add": "Add LAN Route",
          "edit": "Save LAN Route",
          "error": "There was an error saving the LAN Route. Please try again.",
          "success": "Successfully saved LAN Route."
        },
        "title": "LAN Routes",
        "warnings": {
          "lan_mode_firewall": "LAN routes cannot be used in NAT firewall mode. Switch to static or DHCP mode to re-enable."
        }
      },
      "no_data": "No LAN routes available",
      "title": "LAN Routes",
      "title-tooltip": "A static route with the gateway IP address set using the Routed via field. The gateway IP address must be an IP address from an already existing Bigleaf Public IP block, which is configured on the customer equipment connected to the Bigleaf router LAN port(s)"
    },
    "mode": {
      "title": "LAN Mode",
      "tooltip": "<b>Static</b>: Static IP blocks<br/><b>DHCP</b>: Usable IP(s) will be served via DHCP on the LAN port(s)<br /><b>NAT Firewall</b>: Private LAN subnet served via DHCP<br /><b>NAT Firewall + VLANs</b>: Private LAN subnet served via DHCP with support for VLANs",
      "warnings": {
        "lan_routes": "LAN routes cannot be used in NAT firewall mode and will be disabled."
      }
    },
    "public_ips_table": {
      "actions": {
        "delete": "Delete",
        "edit": "Edit",
        "new": "New IP block"
      },
      "columns": {
        "default_gateway": "Default Gateway",
        "enabled": "Enabled",
        "ha_switch": "Switch",
        "ha_vip": "Default gateway",
        "network": "Public IP Block",
        "pop_id": "POP",
        "primary_cpe": "Default Gateway",
        "primary_ip": "Primary router",
        "primary_netmask": "Subnet Mask",
        "secondary_cpe": "Secondary router",
        "unused_ips": "Usable IPs"
      },
      "delete": {
        "active": "Public IP is currently in use by a LAN route",
        "confirm": "Are you sure you want to delete this Public IP?",
        "success": "Public IP has been successfully deleted."
      },
      "drawer": {
        "configure-manually": "Configure manually",
        "configure-with-allocation": "Configure with allocation",
        "errors": {
          "allocation_limit_exceeded": "IP block will exceed the maximum allocation of {{limit}} IP addresses per site. Reduce the number of IPs or delete an existing block to free up space."
        },
        "new": "New Public IP",
        "submit": {
          "add": "Add Public IP",
          "edit": "Save Public IP",
          "error": "There was an error saving the Public IP. Please try again.",
          "success": "Successfully saved Public IP."
        },
        "title": "Public IPs",
        "warnings": {
          "allocation_limit_exceeded": "IP block will exceed the maximum allocation of {{limit}} IP addresses per site",
          "lan_mode_firewall": "Public IPs cannot be used in NAT firewall mode. Switch to static or DHCP mode to re-enable.",
          "pop_id_mismatch": "The selected PoP does not match the default PoP. This may degrade performance."
        }
      },
      "no_data": "No Public IPs available",
      "title": "Public IPs",
      "title-tooltip": "The default Bigleaf IP address allocation, which is commonly known as an interface network. The Default gateway is configured on the Bigleaf router LAN port(s)",
      "title-tooltip-firewall": "In NAT firewall mode, Public IP address blocks are only available for use with the 1:1 NAT feature, and every IP address in the block is usable.",
      "warnings": {
        "lan_mode_firewall": "Public IPs cannot be used in NAT firewall mode. Switch to static or DHCP mode to re-enable."
      }
    },
    "vlans_table": {
      "actions": {
        "delete": "Delete",
        "edit": "Edit",
        "max_vlans": "A maximum of {{count}} VLANs are allowed",
        "new": "New VLAN network"
      },
      "columns": {
        "address": "Local address",
        "description": "Description",
        "device_port": "Device Port",
        "name": "VLAN Name",
        "subnet": "Subnet (CIDR)",
        "vlan_id": "VLAN ID"
      },
      "delete": {
        "confirm": "Are you sure you want to delete this VLAN?",
        "success": "VLAN has been successfully deleted."
      },
      "dhcp_enabled_toggle": {
        "confirmation": {
          "cancel": "Cancel",
          "disable_confirm": "Disable DHCP",
          "disable_dhcp": "Are you sure you want to disable DHCP on VLANs?",
          "enable_confirm": "Enable DHCP",
          "enable_dhcp": "Are you sure you want to enable DHCP on VLANs?",
          "success": "DHCP on VLANs has been updated."
        },
        "label": "DHCP enabled"
      },
      "drawer": {
        "form": {
          "errors": {
            "address_not_in_subnet": "Address must be within subnet",
            "invalid_vlan_id": "VLAN ID {{value}} is not allowed",
            "max_length": "Maximum length is {{maxLength}}",
            "subnet_invalid_cidr": "Subnet is not in CIDR notation"
          },
          "fields": {
            "address": {
              "label": "Local address",
              "placeholder": "e.g. 192.168.20.1"
            },
            "description": {
              "label": "Description",
              "placeholder": "What the VLAN is used for"
            },
            "device_port": {
              "label": "Device port"
            },
            "name": {
              "label": "VLAN name",
              "placeholder": "Provide a name"
            },
            "subnet": {
              "label": "Subnet (CIDR)",
              "placeholder": "e.g. 192.168.20.0/24"
            },
            "vlan_id": {
              "label": "VLAN ID",
              "placeholder": "e.g. 20",
              "tooltip": "Valid range: 2–4094. ID 200 is reserved for internal use only."
            }
          }
        },
        "header": {
          "add": "New VLAN",
          "edit": "Edit VLAN"
        },
        "submit": {
          "add": "Add VLAN",
          "edit": "Save VLAN",
          "error": "There was an error saving the VLAN. Please try again.",
          "success": "Successfully saved VLAN."
        },
        "title": "VLANs"
      },
      "no_data": "No VLANs available",
      "title": "VLANs"
    }
  },
  "nat_rules": {
    "delete_dialog": {
      "api_error": "There was an error deleting NAT rule.",
      "delete_success": "Successfully deleted NAT rule.",
      "text": "Are you sure you want to delete this NAT rule?"
    },
    "delete_last_rule_dialog": {
      "api_error": "There was an error deleting NAT rule.",
      "delete_success": "Successfully deleted NAT rule.",
      "text": "This will also delete the 1:1 NAT rule since there are no remaining port/protocol rules."
    },
    "delete_route_dialog": {
      "api_error": "There was an error deleting protocol/port rule.",
      "delete_success": "Successfully deleted protocol/port rule.",
      "text": "Are you sure you want to delete this protocol/port rule?"
    },
    "drawer": {
      "form": {
        "add": {
          "submit": "Add NAT rule"
        },
        "available_ips_error": "Unable to load available IPs. Please try again.",
        "edit": {
          "submit": "Save NAT rule"
        },
        "fields": {
          "allowed_remote_ips": {
            "invalid_format": "'{{value}}' is not a valid CIDR or IP address",
            "label": "Allowed remote IPs",
            "placeholder": "e.g. Any"
          },
          "lan_ip": {
            "label": "Internal IP",
            "message": "The internal IP address to map to",
            "placeholder": "Select internal IP",
            "required": "Internal IP address is required"
          },
          "name": {
            "label": "Name"
          },
          "ports": {
            "label": "Ports",
            "placeholder": "e.g. 25"
          },
          "protocol": {
            "label": "Protocol",
            "options": {
              "ALL": "Any",
              "ICMP": "ICMP",
              "TCP": "TCP",
              "UDP": "UDP"
            }
          },
          "public_ip": {
            "label": "Public IP",
            "message": "The public IP address to expose",
            "placeholder": "Select Public IP",
            "required": "Public IP address is required"
          }
        }
      },
      "header": {
        "description": "Map a public IP address to an internal IP address for 1:1 NAT.",
        "title": {
          "add": "New NAT rule",
          "edit": "Edit NAT rule"
        }
      },
      "port_protocol_rules": {
        "add_rule": "Add protocol/port rule",
        "description": "You can define multiple protocols and ports for this mapping. Each entry acts as a match condition under the same NAT rule.",
        "field": {
          "allowed_remote_ips": {
            "label": "Allowed remote IPs",
            "placeholder": "e.g. 203.0.113.42/32"
          },
          "ports": {
            "label": "Ports",
            "placeholder": "Port or port range, e.g. \"22\" or \"22 - 24\""
          },
          "protocol": {
            "label": "Protocol",
            "placeholder": "Select the protocol type"
          }
        },
        "remove_rule": "Remove rule"
      },
      "port_protocols": {
        "add": "Add protocol/port rule",
        "description": "You can define multiple protocols and ports for this mapping. Each entry acts as a match condition under the same NAT rule.",
        "remove": "Remove rule"
      },
      "submit": {
        "add": "Add NAT rule",
        "api_error": "There was an error saving NAT rule.",
        "edit": "Save NAT rule",
        "success": "Successfully saved NAT rule."
      },
      "title": "NAT rules"
    },
    "table": {
      "actions": {
        "delete": "Delete NAT rule",
        "edit": "Edit NAT rule",
        "error": {
          "toggle_enabled": "Failed to update NAT rule enabled state.",
          "toggle_logging": "Failed to update NAT rule logging state."
        },
        "toggle_enabled": "Toggle rule enabled",
        "toggle_logging": "Toggle rule logging"
      },
      "allowed_remote_ips_any": "Any",
      "button": {
        "delete_rule": "Delete NAT rule",
        "edit_rule": "Edit NAT rule",
        "new_rule": "New NAT rule",
        "new_rule_disabled_tooltip": "Security suite with an active NAT firewall must be enabled to manage NAT rules."
      },
      "column": {
        "action": "Action",
        "allowed_remote_ips": "Allowed remote IPs",
        "enabled": "Enabled",
        "hits": "Hits",
        "lan_ip": "Internal IP",
        "logging": "Logging",
        "name": "Name",
        "port_rules": "Protocol/Ports",
        "ports": "Ports",
        "protocol": "Protocol",
        "public_ip": "Public IP"
      },
      "ip_and_client_name": "{{ip}} ({{client_name}})",
      "no_data": "No NAT rules",
      "no_port_rules": "No protocol/port rules",
      "rules_sub_row": {
        "actions": {
          "add_rule": "Add protocol/port rule",
          "delete": "Delete protocol/port rule",
          "edit": "Edit protocol/port rule"
        }
      },
      "sub_row_info": "All protocol/port rules under this NAT mapping follow the parent rule's status and logging settings.",
      "subtitle": "Map a public IP address to a private device. Each NAT rule can contain multiple protocol and port combinations. Expand a rule to view or edit individual conditions.",
      "title": "NAT rules (1:1)"
    }
  },
  "port_forwarding": {
    "delete_dialog": {
      "api_error": "There was an error deleting port forwarding rule.",
      "delete_success": "Successfully deleted port forwarding rule.",
      "text": "Are you sure you want to delete this port forwarding rule?"
    },
    "form": {
      "add": {
        "api_error": "There was an error adding port forwarding rule.",
        "submit": "Add port forwarding rule",
        "submit_success": "Successfully added port forwarding rule.",
        "title": "New port forwarding rule"
      },
      "edit": {
        "api_error": "There was an error saving port forwarding rule.",
        "submit": "Save port forwarding rule",
        "submit_success": "Successfully saved port forwarding rule.",
        "title": "Edit port forwarding rule"
      },
      "field": {
        "allowed_remote_ips": {
          "invalid_format": "'{{value}}' is not in CIDR notation",
          "label": "Allowed remote IPs",
          "placeholder": "E.g. 203.0.113.42/32",
          "required": "Allowed remote IPs are required",
          "required_protocol": "Allowed remote IPs are required for {{protocol}} protocol rule",
          "required_restricted_ports": "Allowed remote IPs are required if ports include any of: {{ports}}"
        },
        "description": {
          "label": "Description"
        },
        "ip": {
          "label": "Internal IP address",
          "load_error": "Unable to load available IPs. Please try again.",
          "placeholder": "E.g. 192.168.0.10",
          "validation": {
            "invalid_format": "Please enter a valid IP address.",
            "required": "$t(port_forwarding.form.field.ip.label) is required."
          }
        },
        "port": {
          "label": "External port(s)",
          "placeholder": "Port or port range, e.g. \"22\" or \"22 - 24\"",
          "validation": {
            "invalid_format": "$t(port_forwarding.form.field.port.label) must be an integer or integer range expressed with a dash (-).",
            "invalid_range": "Lower port range bound cannot be greater than the upper bound.",
            "invalid_value": "$t(port_forwarding.form.field.port.label) must be integer(s) greater than or equal to {{min}} and less than or equal to {{max}}.",
            "required": "$t(port_forwarding.form.field.port.label) is required."
          }
        },
        "protocol": {
          "label": "Protocol"
        },
        "public_ip": {
          "label": "Public network"
        }
      },
      "no_static_ips": "You must have at least one LAN client with a static IP to create port forwarding rules.<br />Visit the “LAN Clients” tab to specify a static IP for one or more of your LAN clients."
    },
    "table": {
      "actions": {
        "error": {
          "toggle_enabled": "Failed to update port forwarding rule enabled state.",
          "toggle_logging": "Failed to update port forwarding rule logging state."
        },
        "toggle_enabled": "Toggle rule enabled",
        "toggle_logging": "Toggle rule logging"
      },
      "all": "ALL",
      "allowed_remote_ips_any": "Any",
      "api_error": "There was an error loading port forwarding rules.",
      "button": {
        "copy_all": "Copy all",
        "delete_rule": "Delete rule",
        "edit_rule": "Edit rule",
        "new_rule": "New rule",
        "new_rule_disabled_tooltip": "There are no static IP LAN clients."
      },
      "column": {
        "allowed_remote_ips": "Allowed remote IPs",
        "description": "Description",
        "enabled": "Enabled",
        "hits": "Hits",
        "ip": "Internal IP address",
        "logging": "Logging",
        "port_start": "External port",
        "protocol": "Protocol",
        "public_ip": "Public network"
      },
      "ip_and_client_name": "{{ip}} ({{client_name}})",
      "no_data": "No port forwarding rules",
      "port_range": "{{port_start}} - {{port_end}}",
      "subtitle": "A LAN-side static IP address is required to ensure consistent port forwarding to your device. You can set this up in the LAN Clients configuration tab. See <a>the support article</a> for details.",
      "title": "Port forwarding rules"
    },
    "title": "LAN Clients"
  },
  "print-configuration": {
    "dns": "DNS {{index}}",
    "document-title": "Bigleaf Configuration Details",
    "gateway-ip": "Gateway IP",
    "header": "Configuration Details",
    "lan-ip-addressing": "LAN IP Addressing",
    "notes": "Notes",
    "print-configuration": "Print configuration",
    "quality-check": "Quality checked with care by: {{name}}",
    "subnet-mask": "Subnet Mask",
    "usable-ips": "Usable IP(s)",
    "wan": "WAN {{index}}",
    "wan-port-assignments": "Wan Port Assignments"
  },
  "provision-site": {
    "confirm": "Warning: Provisioning will start the billing process - are you sure you wish to proceed?",
    "error": "Unable to provision site. Click for more details.",
    "error_toast": "Unable to provision site for the following reasons:",
    "provision_site": "Provision site",
    "provisioned_at": "Provisioned on {{date}}",
    "requires": "The cpes need to be online, running the most recent firmware version with an up to date site config version.",
    "success": "Site successfully provisioned",
    "unsaved_changes": "Please save before attempting to provision"
  },
  "rules": {
    "add-download-rule": "Add download rule",
    "add-upload-rule": "Add upload rule",
    "delete": {
      "cancel-setup": "Cancel rule setup",
      "label": "Delete rule",
      "mark-for-deletion": "Delete rule",
      "marked-for-deletion-description": "Marked for deletion",
      "unmark-for-deletion": "Unmark for deletion"
    },
    "description": "Set up custom QoS rules at your site to prioritize business-critical traffic or manually classify traffic. Refer to <a>our support article</a> for further details.",
    "group-download": {
      "rule-title": "Custom download rule {{rule_index}}",
      "title": "Custom QoS rules: DOWNLOAD"
    },
    "group-upload": {
      "rule-title": "Custom upload rule {{rule_index}}",
      "title": "Custom QoS rules: UPLOAD"
    },
    "missing-permission": "If you'd like to use custom QoS rules, contact <a>Bigleaf Support</a>. We can help you determine how an application or service is being classified, and create a custom rule if necessary.",
    "move-rule-down": "Move down",
    "move-rule-up": "Move up",
    "no-rules-warn": "You don’t have any custom QoS rules",
    "rule-labels": {
      "description": "Option notes",
      "qos-class": "Traffic type",
      "rule-data": "Rule"
    }
  },
  "staged-configuration": {
    "apply-modal": {
      "cancel": "Back",
      "confirm": "Yes, Apply changes",
      "description-1": "This will apply all staged changes to the site.",
      "description-2": "Downtime may occur depending on the changes, so ensure all updates have been reviewed.",
      "title": "Apply staged changes to the active site?"
    },
    "create-config": "Create/stage configuration changes for future application",
    "discard-changes": "Discard Changes",
    "discard-changes-confirm": "Do you want to discard these changes?",
    "edit-config": "Edit or review existing staged configuration changes",
    "keep-changes": "Keep Changes",
    "locked-config": "Your configuration is now locked because another configuration is pending. Reach out to support if you need to make time-sensitive changes to your site’s configuration.",
    "locked-config-envop": "Your configuration is now locked because another configuration is pending. In order to change current settings you need to remove the staged configuration.",
    "review-modal": {
      "cancel": "Cancel",
      "comparison-badge": {
        "added": "Added",
        "deleted": "Deleted",
        "modified": "Modified"
      },
      "comparison-type": {
        "after": "After",
        "before": "Before"
      },
      "confirm": "Apply changes",
      "description": "You've made changes to this site configuration. Review them below. When ready apply to go live - or close to keep editing.",
      "fields": {
        "site": {
          "primary_pop_id": "Primary PoP",
          "secondary_pop_id": "Secondary PoP"
        }
      },
      "title": "Review your changes"
    },
    "staged-changes": "Changes will be staged but not applied to the site. To apply changes, click the “Review & apply” button in the header"
  },
  "vpn": {
    "connections_table": {
      "actions": {
        "delete": "Delete VPN Connection",
        "edit": "Edit VPN Connection",
        "error": {
          "fetch": "Failed to load VPN connection details.",
          "toggle_enabled": "Failed to update VPN connection enabled state."
        },
        "toggle_enabled": "Toggle connection enabled"
      },
      "add": {
        "button": "New VPN connection",
        "disabled_tooltip": "A maximum of {{max}} VPNs are allowed"
      },
      "columns": {
        "enabled": "Enabled",
        "ip": "Remote IP",
        "local_subnets": "Local Subnet(s)",
        "name": "Connection Name",
        "remote_subnets": "Remote Subnet(s)",
        "status": "Status"
      },
      "delete": {
        "confirm_text": "Are you sure you want to delete this VPN connection?",
        "success": "VPN connection has been successfully deleted."
      },
      "drawer": {
        "fields": {
          "ip": {
            "label": "Remote IP",
            "placeholder": "e.g. 52.11.34.55"
          },
          "local_subnets": {
            "label": "Local subnet(s)",
            "placeholder": "Select subnet(s)"
          },
          "name": {
            "label": "Connection name",
            "placeholder": "e.g. site-to-AWS"
          },
          "phase_1": {
            "authentication": {
              "label": "Integrity/PRF"
            },
            "diffie_hellman_group": {
              "label": "Diffie-Hellman group"
            },
            "encryption": {
              "label": "Encryption algorithm"
            },
            "sa_lifetime": {
              "label": "SA lifetime (in seconds)"
            }
          },
          "phase_2": {
            "authentication": {
              "label": "Integrity"
            },
            "diffie_hellman_group": {
              "label": "PFS/Diffie-Hellman group"
            },
            "encryption": {
              "label": "Encryption algorithm"
            },
            "sa_lifetime": {
              "label": "SA lifetime (in seconds)"
            }
          },
          "preset_proposal": {
            "label": "Preset proposal",
            "options": {
              "custom": "Custom"
            },
            "placeholder": "Select preset proposal"
          },
          "remote_subnets": {
            "label": "Remote subnet(s)",
            "message": "Add remote subnet(s) and click Enter",
            "placeholder": "e.g. 192.168.1.1/24"
          },
          "shared_key": {
            "label": "Pre-shared key",
            "placeholder": "Enter pre-shared key"
          }
        },
        "header": {
          "add": "New VPN connection",
          "edit": "Edit VPN connection"
        },
        "none_option": "None",
        "phase": "Phase {{phase}}",
        "security_proposal_settings": "Security proposal settings",
        "submit": {
          "add": "Add connection",
          "edit": "Save connection",
          "error": "There was an error saving the VPN Connection. Please try again.",
          "success": "Successfully saved VPN Connection."
        },
        "title": "VPN",
        "validation": {
          "ip": {
            "invalid": "IP address must be valid"
          },
          "required": "Field is required",
          "sa_lifetime": {
            "max": "SA Lifetime must be no more than {{max}} seconds",
            "min": "SA Lifetime must be no less than {{min}} seconds",
            "phase2_exceeded": "Lifetime for Phase 2 must be less than for Phase 1"
          },
          "shared_key": {
            "max": "Pre-shared key must be no more than {{max}} characters",
            "min": "Pre-shared key must be at least {{min}} characters",
            "no_leading_zero": "Pre-shared key cannot begin with a zero"
          },
          "subnet": {
            "invalid_cidr": "'{{value}}' is not in CIDR notation",
            "not_allowed": "'{{value}}' is not allowed"
          }
        }
      },
      "no_data": "No VPN Connections available",
      "subnets": "Subnets",
      "title": "VPN connections"
    },
    "logs": {
      "enabled": "Enable VPN logging",
      "error": "Failed to update VPN logging state",
      "title": "VPN Logs"
    },
    "status": {
      "down": "Down",
      "up": "Up"
    }
  },
  "welcome-card": {
    "dismiss": "Dismiss",
    "header": "Welcome to the new site configuration page",
    "read-more": "Read more",
    "reminder": "<b>Reminder:</b> Depending on your permissions, you can directly edit all tabs. Just don't forget to click \"Save changes\"to apply updates to your site.",
    "summary": "We've given the site configuration page a fresh redesign to make your life easier. All settings are in tabs now, grouped for your convenience. We introduced a few more improvements to make the experience more intuitive. ",
    "tabbed-layout": "<b>Tabbed Layout</b>: Navigate seamlessly with these handy tabs:",
    "tabs": {
      "circuits": "<b>Circuits:</b> Add, update, or remove WAN circuits.",
      "custom-qos": "<b>Custom QoS:</b> Configure custom QoS prioritization rules for your site.",
      "devices": "<b>Devices:</b> Assign or remove devices and tweak port settings.",
      "general": "<b>General:</b> Adjust site settings, addresses, PoP locations, and service options.",
      "lan-settings": "<b>LAN Settings:</b> Modify LAN mode and network configurations."
    },
    "tooltips": "<b>Helpful Tooltips and Warnings:</b> Need guidance? Look out for tooltips and warnings to keep you on track while configuring.",
    "unified-mode": "<b>Unified Mode</b>: No more switching between read and edit modes. Configuration is always in edit mode now, but your changes won't stick until you hit \"Save changes\". (If you don't have edit permissions, don't worry—your view will be read-only.)"
  },
  "wi_fi": {
    "band": {
      "BAND_2GHZ": "2.4 GHz Wi-Fi network",
      "BAND_5GHZ": "5 GHz Wi-Fi network"
    },
    "firewall_alert": "You need to enable NAT firewall in order to configure Wi-Fi.",
    "networks": {
      "guest": {
        "title": "Guest Wi-Fi network",
        "toggle": "Enable guest Wi-Fi network"
      },
      "primary": {
        "title": "Primary Wi-Fi network",
        "toggle": "Enable primary Wi-Fi network"
      }
    }
  }
}
